import {
  type EstimateIntercityOrderResponse,
  type EstimateNewOrderRequestBody,
  type DefaultQueryError,
  estimateNewOrderFn,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { ESTIMATE_FEE_ACCEPTS_VERSION } from '@/lib/constants';

export const useEstimateOrder = (
  opts?: UseMutationOptions<
    EstimateIntercityOrderResponse[],
    DefaultQueryError,
    EstimateNewOrderRequestBody
  >
) =>
  useMutation<
    EstimateIntercityOrderResponse[],
    DefaultQueryError,
    EstimateNewOrderRequestBody
  >({
    mutationKey: ['estimateNewOrderFn'],
    mutationFn: (body) =>
      estimateNewOrderFn(body, {
        headers: { 'accepts-version': ESTIMATE_FEE_ACCEPTS_VERSION },
      }),
    ...opts,
  });
